module.exports = __webpack_public_path__ + "img/rtc2.36141fcf.png";